export default "__VITE_ASSET__j1zZV$QQ__"